<div class="card {{ fullCard }} {{ cardLoad }}" [@cardClose]="cardClose" [ngClass]="cardClass">
  <div class="card-header" *ngIf="hideHeader === false" [ngClass]="headerClass">
    <h5 class="d-flex align-items-center" [ngClass]="headerTitleClass" *ngIf="title"> <i *ngIf="titleHasIcon" class="title-icon fa fa-lg fa-check-circle-o" [ngClass]="{'inactive': !titleIconActive}" aria-hidden="true"></i>{{ title }}</h5>
    <ng-container *ngTemplateOutlet="customTitle">

    </ng-container>
    <span *ngIf="!classHeader">{{ headerContent }}</span>
    <span *ngIf="!classHeader" [innerHTML]="innerHtmlHeader"></span>
    <span *ngIf="classHeader">
      <ng-content select=".code-header"></ng-content>
    </span>


<!--button advanced-->
    <div class="card-button text-end" *ngIf="advanceButton">
      <ng-container *ngIf="showActionButtons">
        <button class="btn ms-4"
                [ngClass]="btn.btnCustomClass"
                *ngFor="let btn of advancedButtons"
                (click)="redirectToUrlAdvanced( btn)">
          <i *ngIf="btn.btnIcon" class="{{btn.btnIcon}}"></i>
          <label class="mb-0" [ngClass]="(btn.btnIcon?'ms-1':'') + ' ' + (btn.btnIconAfter?'me-1':'')">
            {{btn.btnName}}
          </label>
          <i *ngIf="btn.btnIconAfter" class="{{btn.btnIconAfter}}"></i>
        </button>
      </ng-container>
      
      <div ngbDropdown placement="bottom-right" class="d-inline-block ms-4" *ngIf="dropdownButton">
        <button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>{{dropdownButton.name}}</button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button class="dropdown-item"
                  *ngFor="let dropDownItem of dropdownButton.dropdownItems"
                  [attr.data-testid]="dropDownItem.key ? 'export-' + dropDownItem.key : null"
                  (click)="redirectToUrlDropDownItem(dropDownItem)">{{dropDownItem.btnName}}</button>
        </div>
      </div>
    </div>

    <!--button simple-->
    <div class="card-Singel-button">
      <button *ngIf="cardOptionBtn"
              type="button"
              [ngClass]="simpleBtnCustomClass"
              (click)="redirectToUrl()">
        <i *ngIf="cardOptionBtnIcon" class="{{cardOptionBtnIcon}}"></i>
        <label class=" mb-0" [ngClass]="cardOptionBtnIcon?'ms-1':''"> {{cardOptionBtnValue}}</label>

      </button>
    </div>

    <div class="card-header-right" *ngIf="!cardOptionBlock">
      <ul class="list-unstyled card-option" [@cardIconToggle]="cardIconToggle">
        <li *ngIf="!isCardToggled" (click)="toggleCardOption()"><i class="feather open-card-option icon-chevron-left"></i></li>
        <li *ngIf="fullScreenButton"><i class="feather {{ fullCardIcon }} full-card" (click)="fullScreen($event)"></i></li>
        <li *ngIf="minimizeButton"><i class="feather minimize-card icon-minus" appCardToggleEvent (click)="toggleCard($event)"></i></li>
        <li *ngIf="refreshButton"><i class="feather icon-refresh-cw reload-card" (click)="cardRefresh($event)" ></i></li>
        <li *ngIf="closeButton"><i class="feather icon-trash close-card" (click)="closeCard($event)"></i></li>
        <li *ngIf="isCardToggled" (click)="toggleCardOption()"><i class="feather open-card-option icon-x"></i></li>
      </ul>
    </div>
  </div>

  <div [@cardToggle]="cardToggle" class="card-block-hid">
    <div class="card-block" [ngClass]="blockClass">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="card-loader" *ngIf="loadCard"><i class="fa fa-spinner rotate-refresh"></i></div>
</div>
